import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { FiPlay } from "react-icons/fi";

// Robust slugify function
const slugify = (text) => {
    if (!text || typeof text.toString !== "function") return "unknown";
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w-]+/g, "")
        .replace(/--+/g, "-")
        .replace(/^-+/, "")
        .replace(/-+$/, "");
};

const ASSET_BASE_URL = process.env.REACT_APP_ASSET_BASE_URL;

const BlogList = ({ data, StyleVar }) => {
    const categories = Array.isArray(data.categories) ? data.categories : [];


    const cate = categories.map((value, i) =>
        value ? (
            <Link to={`/category/${slugify(value)}`} key={i}>
                {value}
                {i !== categories.length - 1 && ","}
            </Link>
        ) : null
    );

    return (
        <div className={`rn-card ${StyleVar}`}>
            <div className="inner">
                <div className="thumbnail position-relative">
                    <Link to={`/content-details/${data.id}`} className="image">
                    
                    
                        <img
                            src={`${ASSET_BASE_URL}/storage/${data.image}`}
                            alt="Content Image"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/images/default-image.jpg"; // your fallback image
                            }}
                        />
                    </Link>

                    {data.video_url && (
                        <Link to={`/content-details/${data.id}`}>
                            <div
                                className="play-button-overlay d-flex align-items-center justify-content-center"
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    backgroundImage:
                                        "linear-gradient(95deg, rgb(5, 157, 255) 15%, rgb(101, 73, 213) 45%, rgb(227, 63, 161) 75%, rgb(251, 83, 67) 100%)",
                                    borderRadius: "50%",
                                    width: "70px",
                                    height: "70px",
                                    color: "#fff",
                                    fontSize: "30px",
                                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    cursor: "pointer",
                                }}
                            >
                                <FiPlay />
                            </div>
                        </Link>
                    )}
                </div>
                <div className="content">
                    <ul className="rn-meta-list">
                        <li>
                            <Link to={`/archive/${slugify(data.author || "Unknown")}`}>
                                {data.author || "Unknown Author"}
                            </Link>
                        </li>
                        <li className="separator">/</li>
                        <li>{data.date}</li>
                    </ul>
                    <h4 className="title">
                        <Link to={`/content-details/${data.id}`}>
                            {data.title}
                        </Link>
                    </h4>
                    <div className="post-categories">{cate}</div>
                </div>
            </div>
        </div>
    );
};

BlogList.propTypes = {
    data: PropTypes.object.isRequired,
    StyleVar: PropTypes.string,
};

export default BlogList;
